import { useState, useEffect } from 'react';
import _ from "lodash";

import SmartCarnetActions from "../actions/SmartCarnetActions";

const useSmartCarnetTicketDetails = (ticketID, hasSmartCarnetTrip) => {

    const [smartCarnetTicketDetails, setSmartCarnetTicketDetails] = useState({});
    const [isLoadingSmartCarnetTicketDetails, setIsLoadingSmartCarnetTicketDetails] = useState(false);

    useEffect(() => {
        if (ticketID && hasSmartCarnetTrip) {
            _.defer(async () => {
                setIsLoadingSmartCarnetTicketDetails(true);
                try {
                    const result = await SmartCarnetActions.getSmartCarnetTicketDetails(ticketID);
                    setSmartCarnetTicketDetails(result);
                } catch (e) {
                    setSmartCarnetTicketDetails({});
                } finally {
                    setIsLoadingSmartCarnetTicketDetails(false);
                }
            });
        }
    }, [ticketID, hasSmartCarnetTrip]);

    return {
        smartCarnetTicketDetails,
        isLoadingSmartCarnetTicketDetails,
    };
};

export default useSmartCarnetTicketDetails;



// WEBPACK FOOTER //
// ./src/hooks/useSmartCarnetTicketDetails.js